<template>
  <div
    class="detail-container"
    :class="{true: hideTwoPay}"
  >
    <div
      class="detail-content"
      v-if="orderDeatil.orderNo"
    >
      <div class="heard">
        <i
          class="icon"
          :class="orderDeatil.statusCode"
        />
        <div class="desc">
          <p class="state">
            {{ orderDeatil.statusName }}
          </p>
          <p
            class="txt"
            v-if="orderDeatil.statusCode ==='TO_BE_PAY'"
          >
            剩余付款时间 {{ timeTxt }} 秒
          </p>
          <p
            class="txt"
            v-if="orderDeatil.statusCode !='TO_BE_PAY'"
          >
            {{ statusDesc }}
          </p>
        </div>
      </div>
      <div class="goods-detail">
        <div class="img-box">
          <img
            v-lazy="picUrls"
            class="img"
          />
        </div>
        <div class="info">
          <p class="name-money">
            <span class="name">{{ orderDeatil.reSkuId ? orderDeatil.reProductName : orderDeatil.productName }}</span>
            <span class="money">￥{{ (orderDeatil.proPrice / orderDeatil.num).toFixed(2) }}</span>
          </p>
          <p class="attrs-num">
            <span class="attrs">{{ orderDeatil.reSkuId? orderDeatil.reSkuName :(orderDeatil.businessType == '4' ? orderDeatil.attrValues : orderDeatil.skuName) }}</span>
            <span class="num-box">&times;{{ orderDeatil.num }}</span>
          </p>
        </div>
      </div>
      <div class="price-detail">
        <ul>
          <li
            class="item"
            v-if="orderDeatil.businessType!=='4'"
          >
            <span class="name">充值账号</span>
            <span class="num">{{ orderDeatil.account || orderDeatil.target }}</span>
          </li>
          <li class="item">
            <span class="name">商品总额</span>
            <span class="num">￥{{ orderDeatil.proPrice.toFixed(2) }}</span>
          </li>
          <li
            class="item"
            v-if="orderDeatil.couponDiscount !== 0"
          >
            <span class="name">优惠金额</span>
            <span class="num">￥{{ orderDeatil.couponDiscount || 0 }}</span>
          </li>
          <li class="item">
            <span class="name">实付金额</span>
             <span class="num price">￥{{ orderDeatil.reSkuId && orderDeatil.reDealPrice? orderDeatil.reDealPrice.toFixed(2): orderDeatil.dealPrice.toFixed(2)  }}</span>
            <!-- <span class="num price">￥{{ orderDeatil.dealPrice.toFixed(2) }}</span> -->
          </li>
        </ul>
      </div>


      <div class="contentBehalf" v-if="behalfdetail && behalfdetail.record">
        <div class="behalfHead">
          <h2>返话费记录</h2>
          <p>待返还金额：{{ behalfdetail.refundAmount }} 元<span> 开始日期：{{ behalfdetail.startDate }}</span></p>
        </div>
        <div class="behalfCont">
          <h2 class="clearfix"><span>返还时间</span><span>金额</span><span>是否到账</span></h2> 
            <ul>
              <li
               v-for="(item, index) in behalfdetail.record"
              :key="index"
              >
                <p class="clearfix"><span>{{ item.monthlyAmountDate }}</span><span>{{ item.monthlyAmount }}</span><span :class="{'active':item.isArrival== 'N'}" >{{ item.isArrival == 'Y' ? '是' : '-' }}</span></p>
              </li>
            </ul>
        </div>
      </div>

      <div class="producDetailed" v-if="orderChild.length">
        <div class="detailedHead">
          <h2>商品清单</h2>
        </div>
        <div class="detailedCont">
          <ul>
            <li v-for="(item, index) in orderChild"
              :key="index"
              >
                <div class="goods-detail">
                <div class="img-box">
                  <img
                    v-lazy="picUrls"
                    class="img"
                  />
                </div>
                <div class="info">
                  <p class="name-money">
                    <span class="name">{{ item.productName }}</span>
                    <!--<span class="money">￥{{ (item.proPrice / item.num).toFixed(2) }}</span>-->
                  </p>
                  <p class="attrs-num">
                    <span class="attrs">{{ item.businessType == '4' ? item.attrValues : item.skuName }}</span>
                    <span class="num-box">&times;{{ item.num }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>




      <div
        class="adress-detail"
        v-if="orderDeatil.businessType==='4'"
      >
        <ul>
          <li class="item">
            <span class="name">收货人&nbsp;&nbsp;&nbsp;&nbsp;：</span>
            <span class="num">{{ orderDeatil.contactName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ orderDeatil.contactPhone }}</span>
          </li>
          <li class="item">
            <span class="name">收货地址：</span>
            <span class="num">{{ orderDeatil.contactAddress }}</span>
          </li>
          <li
            class="item"
            v-if="allInfo.expNo"
          >
            <span class="name">物流公司：</span>
            <span class="num">{{ allInfo.expCompName }}</span>
          </li>
          <li
            class="item expNo"
            v-if="allInfo.expNo"
          >
            <div>
              <span class="name">物流单号：</span>
              <span class="num">{{ allInfo.expNo }}</span>
            </div>
            <span
              class="look"
              @click="express"
            >查看物流</span>
          </li>
        </ul>
      </div>
      <div class="order-detail">
        <ul>
          <li class="item">
            <span class="name">订单编号：</span>
            <span>{{ orderDeatil.orderNo }}</span>
          </li>
          <li class="item">
            <span class="name">下单时间：</span>
            <span>{{ orderDeatil.createTime }}</span>
          </li>
          <li class="item">
            <span class="name">支付方式：</span>
            <span>{{ payMethodName }}</span>
          </li>
        </ul>
      </div>
      <div class="contact-detail">
        <p class="ttl">
          如有问题，请联系客服  8:00~23:00（节假日除外）
        </p>
        <div class="btn-row">
          <a
            v-if="qq && (client.env!='wxMini' && client.env!='wx')"
            :href="qq"
            class="btn"
          ><i class="icon qq"></i>QQ客服</a>
          <a
            :href="'tel:' + tel"
            class="btn"
          ><i class="icon tel"></i>客服电话</a>
        </div>
      </div>
      <div
        class="fix-content"
        v-if="!hideTwoPay"
      >
        <order-button
          :type="'detail'"
          :status-code="orderDeatil.statusCode"
          :order-no="orderDeatil.orderNo"
          :exp-no="orderDeatil.expNo"
          :exp-comp-name="orderDeatil.expCompName"
          @setOrderActionInfo="setOrderActionInfo"
        />
      </div>
    </div>
    <order-action
      :types="orderActionType"
      :order-deatil="orderDeatil"
      @cancel="setOrderActionInfo"
      @confirmDelOrder="confirmDelOrder"
      @confirmCancelOrder="confirmCancelOrder"
    />
    <error-panel
      :type="type"
      v-if="type"
    />
  </div>
</template>

<script>

  import {mapGetters} from 'vuex'
  import {getRecordDetail, behalfRecord} from '../services/'
  import {getSessionCache, setSessionCache, setStorageCache, getCacheUserInfo, getPayMethodName, getStorageCache, getDate} from '../utils/'
  import {Api} from '../api/'
  import config from '../config/'
  import orderAction from '../components/orderAction'
  import orderButton from '../components/orderButton'

  export default {
    name: 'detail',
    data() {
      return {
        orderDeatil: {},
        behalfdetail: {},
        orderChild:[],
        orderId: '',
        tel: config.companyTel,
        qq: '',
        imgRoot: '',
        // 自有微信支付轮询信息
        type: '', // 错误类型
        timeTxt: '--:--:--',
        intervalFn: false,
        orderActionType: '' // 二次确认弹窗类型 取消订单 删除订单
        , difference: 0
        , hideTwoPay: config.hideTwoPay // 不出现二次支付
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
        , client: 'client' // 客户端信息
      }),
      allInfo() {
        let info = {address: '', name: '', orderStatus: '', expCompName: '', expNo: ''}
        if (this.orderDeatil.trades && this.orderDeatil.trades[0]) {
          let {ext, expNo, expCompName, statusName} = this.orderDeatil.trades[0]
          info.address = ext.CONTACT_DISTRICT + ext.CONTACT_ADDRESS
          info.name = ext.CONTACT_USER + '  ' + ext.CONTACT_PHONE
          info.orderStatus = statusName
          if (expNo && expCompName) {
            let expCompCode = this.processExpressCode(expCompName)
            info.expNo = expNo
            info.expCompName = expCompName
            setSessionCache('expressInfo', {expCompName: expCompName, expNo: expNo, expCompCode: expCompCode})
          }
        }
        return info
      },
      amount() {
        if (this.orderDeatil.trades && this.orderDeatil.trades[0]) {
          let {orderItems} = this.orderDeatil.trades[0]
          return orderItems[0].num
        } else {
          return 1
        }
      },
      statusDesc() {
        let {statusCode} = this.orderDeatil
        if (statusCode === 'TO_BE_SHIP') { // 待发货
          return '客官，请勿着急，小二现正抓紧时间发货'
        } else if (statusCode === 'SHIPPING') { // 发货中
          return '客官，您的商品我们正快马加鞭的派送中'
        } else if (statusCode === 'TO_BE_REFUND') { // 待退款
          return '客官，您的退款手续正在处理，请耐心等候'
        } else if (statusCode === 'REFUNDOK') { // 已退款
          return '客官，您的退款已退回原账户，请留意'
        }
        if (statusCode !== 'TO_BE_PAY') {
          this.clearTime()
        }
        return ''
      },
      payMethodName() {
        let {payMethodCode} = this.orderDeatil
        return getPayMethodName(payMethodCode)
      },
      picUrls() {
        let {picUrls} = this.orderDeatil
        return picUrls ? (picUrls.includes('http') ? picUrls : `${this.imgRoot}${picUrls}`) : ''
      }
    },
    mounted() {
      this.orderId = this.$route.query.orderId
      this.tradeId = this.$route.query.tradeId || getSessionCache('tradeId')
      let details = getStorageCache('productInfo')
      if (!this.tradeId && !details) {
        this.$router.back()
      }
      this.imgRoot = Api.imgRoot
      this.qq = `http://wpa.qq.com/msgrd?v=3&uin=${config.companyQQ}&site=qq&menu=yes`
      this.$store.dispatch('getEnv').then(() => {
        this.$store.dispatch('appInfoInitialize')
          .then(() => {
            this.updateUserInfo()
            this.fetchDetail()
            this.getBehalfRecord()
          })
      })
    },
    methods: {
      timeFormat(param) { //小于10的格式化函数
        return param < 10 ? '0' + param : param;
      },
      setTime(nextDate) {
        // 获取当前时间，同时得到活动结束时间数组
        let newTime = (new Date().getTime() + this.difference)
        let endTime = new Date(nextDate).getTime()
        if (endTime - newTime > 0) {
          let time = (endTime - newTime) / 1000;
          // 获取天、时、分、秒
          let day = parseInt(time / (60 * 60 * 24))
          let hours = parseInt(time % (60 * 60 * 24) / 3600)
          if (day > 0) {
            hours = day * 24 + hours
          }
          hours = this.timeFormat(hours)
          let minutes = this.timeFormat(parseInt(time % (60 * 60 * 24) % 3600 / 60))
          let seconds = this.timeFormat(parseInt(time % (60 * 60 * 24) % 3600 % 60))
          this.timeTxt = `${hours}:${minutes}:${seconds}`
        } else {
          this.timeTxt = '00:00:00'
        }
        if (this.timeTxt === '00:00:00') {
          this.orderDeatil = Object.assign({}, this.orderDeatil, {
            statusCode: 'CLOSE',
            statusName: '交易关闭'
          })
          this.clearTime()
        }
      }
      , clearTime() {
        if (this.intervalFn) {
          window.clearInterval(this.intervalFn)
        }
      }
      , updateUserInfo() {
        let cacheUser = getCacheUserInfo()
        if (cacheUser) {
          this.$store.dispatch('updateUserInfo', {data: cacheUser})
        }
      }
      , fetchDetail() {
        if (!this.user.token) {
          this.$router.replace({name: 'index'})
        }
        let _this = this
        let details = getStorageCache('productInfo')
        if (this.tradeId) {
          document.title = '订单详情'
          this.$spinner.open('正在加载数据...')
          getRecordDetail({
            authToken: this.user.token,
            tradeId: this.tradeId
          })
            .then(res => {
              let {data} = res
              this.$spinner.close()
              if (data.success && data.datas) {
                this.orderDeatil = data.datas
                this.$analysis.trackEvent('【订单详情页】', 'material_payment_uv', `${this.orderDeatil.productName}${this.orderDeatil.skuName}`)
                let {statusCode, createTime} = data.datas
                createTime = new Date(createTime.replace(/[-]/g, '/')).getTime()
                let difference = (createTime - new Date().getTime())
                this.difference = (difference > 0 ? difference : 0)
                checkTime({
                  statusCode,
                  createTime
                })
              } else {
                this.type = 'serverError'
              }
            })
            .catch(() => {
              this.$spinner.close()
              this.type = 'serverError'
            })
        } else if (details) {
          document.title = '支付结果'
          this.orderDeatil = details
          let {statusCode, createTime} = details
          checkTime({
            statusCode,
            createTime
          })
          let difference = (createTime - new Date().getTime())
          this.difference = (difference > 0 ? difference : 0)
          this.orderDeatil.createTime = getDate(createTime, true)
          this.$analysis.trackEvent('【支付失败页】', 'material_pay_failed_uv', `${this.orderDeatil.productName}${this.orderDeatil.skuName}`)
        } else {
          this.$router.back()
        }

        function checkTime({statusCode, createTime}) {
          if (statusCode === 'TO_BE_PAY') { // 待支付
            let closeOrderTime = config.closeOrderTime
            let time =(24 * 60 * 60 * 1000)
            try {
            time = closeOrderTime ? parseInt(config.closeOrderTime): (24 * 60 * 60 * 1000)
            } catch(e){
              console.log(e)
            }
            let nextDate = new Date(createTime + time)
            _this.clearTime()
            _this.intervalFn = window.setInterval(() => {
              _this.setTime(nextDate)
            }, 1000)
          }
          _this.type = ''
        }
      }
      , setOrderActionInfo({type}) {
        this.orderActionType = type
      }
      // 取消订单
      , confirmCancelOrder() {
        this.orderDeatil = Object.assign({}, this.orderDeatil, {
          statusCode: 'CLOSE',
          statusName: '交易关闭'
        })
        this.clearTime()
        setStorageCache('productInfo', this.orderDeatil)
      }
      , confirmDelOrder() {
        this.$router.push({name: 'history'})
      },
      // // 请求订单详情
      // fetchOrderdetail () {
      //   let _this = this
      //   this.$spinner.open('正在加载数据...')
      //   // eslint-disable-next-line no-unused-vars
      //   const ver = config.isZhonganHall === 'true' ? '4' : '3'
        
      //   getRecordDetail({
      //     authToken: this.userInfo.token,
      //     // tradeId: this.tradeId
      //     orderId: this.orderId,
      //     // userId: this.userInfo.userID,
      //     // ver
      //     // authToken: this.userInfo.token
      //   })
      //   .then(({ data }) => {
      //     let datas = data.datas
      //     let dataInfo1 = {};
      //     datas.forEach((item, index) => {
      //       let { orderId } = item;
      //       if (!dataInfo1[orderId]) {
      //         dataInfo1[orderId] = {
      //           id: index,
      //           ...item,
      //           productName: item.reProductName || item.productName,
      //           orderId,			
      //           child: []
      //         }
      //       }
      //       dataInfo1[orderId].child.push(item);
      //     });
      //     let list1 = Object.values(dataInfo1);
      //     if(list1[0].child.length > 1){
      //       this.orderChild = list1[0].child
      //     }
      //     this.orderdetail = list1[0];
      //     this.$spinner.close()
      //     let {statusCode, createTime} = data.datas[0]
      //   checkTime({
      //         statusCode,
      //         createTime
      //       })
      //     function checkTime({statusCode, createTime}) {
          
      //       if (statusCode === 'TO_BE_PAY') { // 待支付
      //         let closeOrderTime = config.closeOrderTime  //== 1200000
      //         let time =(24 * 60 * 60 * 1000)
      //         try {
      //         time = closeOrderTime ? parseInt(config.closeOrderTime): (24 * 60 * 60 * 1000)
      //         } catch(e){
      //           console.log(e)
      //         }
      //         // let nextDate = new Date(createTime + time)

      //         let nextDate = new Date(createTime).getTime()
      //         nextDate = nextDate + time
      //         _this.clearTime()
      //         _this.intervalFn = window.setInterval(() => {
      //           _this.setTime(nextDate)
      //         }, 1000)
      //       }
      //       _this.type = ''
      //     }

          
      //   })
      //   .catch(() => {
      //     this.$router.replace({ name: 'error' })
      //     this.$spinner.close()
      //   })
      // },
      getBehalfRecord(){
        console.log('this.orderId', this.orderId)
        console.log('this.tradeId', this.tradeId)
        behalfRecord({
          orderId: this.orderId,
          tradeId: this.tradeId
        })
        .then(({ data }) => {
          if(data.data){
            this.behalfdetail = data.data
          }
        })
        .catch(() => {
        
        })
      }
      
    },
    destroyed() {
      this.clearTime()
      this.$store.dispatch('clearOrderInfo')
    },
    components: {
      orderButton
      , orderAction
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/common.scss";

  .detail-container {
    @extend %container;
    padding-bottom: 195px;
    &.true {
      padding-bottom: 0px;
    }
    .detail-content {
      .heard {
        height: 211px;
        background-image: linear-gradient(
            #fff3b7,
            #fff3b7),
        linear-gradient(-90deg,
            #ffcf13 0%,
            #fde104 100%);
        background-blend-mode: normal,
        normal;
        color: #000000;
        @extend %flex-row;
        padding: 53px 48px 0;
        .icon {
          background-repeat: no-repeat;
          background-size: cover;
          flex: 0 0 auto;
          margin-right: 22px;
          display: none;
          &.TO_BE_PAY {
            background-image: url("../assets/image/icon-clock.png");
            width: 46px;
            height: 46px;
            display: block;
          }
          &.SHIPPING {
            background-image: url("../assets/image/icon-vehicle.png");
            width: 45px;
            height: 37px;
            display: block;
          }
        }
        .desc {
          color: #000000;
          .state {
            font-size: 42px;
            margin-bottom: 5px;
          }
          .txt {
            font-size: 36px;
          }
        }
      }
      .goods-detail,
      .price-detail,
      .adress-detail,
      .order-detail,
      .contentBehalf,
      .contact-detail {
        @extend %content;
      }
      .goods-detail {
        @extend %flex-center-row;
        padding: 50px 28px 28px 28px;
        .img-box {
          width: 215px;
          flex: 0 0 auto;
          @extend %flex-center-center;
          .img {
            width: 170px;
          }
        }
        .info {
          padding-left: 15px;
          width: 100%;
          .name-money {
            font-size: 42px;
            color: #000000;
            padding-bottom: 2px;
            @extend %flex-row;
            justify-content: space-between;
            .money {
              font-size: 36px;
              flex: 0 0 auto;
              padding-left: 120px;
            }
          }
          .attrs-num {
            color: #999999;
            font-size: 36px;
            @extend %flex-row;
            justify-content: space-between;
            .num-box {
              flex: 0 0 auto;
              padding-left: 120px;
            }
          }
        }
      }
      .price-detail,
      .adress-detail {
        .item {
          padding: 58px 37px 10px 39px;
          font-size: 36px;
          color: #000000;
          &:last-child {
            padding-bottom: 58px;
          }
          .name {
            flex: 0 0 auto;
          }
          .price {
            color: #ff0000;
          }
        }
      }
      .price-detail {
        .item {
          @extend %flex-between-center;
        }
      }
      .adress-detail {
        .item {
          @extend %flex-row;
          .look {
            color: #f0af05;
            flex: 0 0 auto;
            text-decoration: underline;
          }
          &.expNo {
            @extend %flex-between-center;
          }
        }

      }
      .order-detail {
        color: #999999;
        font-size: 36px;
        padding: 44px;
        .item {
          padding-bottom: 36px;
          &:last-child {
            padding-bottom: 0px;
          }
        }
      }
      .contact-detail {
        padding: 40px 50px 45px;
        .ttl {
          color: #999999;
          font-size: 36px;
        }
        .btn-row {
          margin-top: 35px;
          @extend %flex-center-center;
          .btn {
            width: 420px;
            height: 90px;
            background-image: linear-gradient(
                #ffffff,
                #ffffff),
            linear-gradient(
                #ffdc00,
                #ffdc00);
            background-blend-mode: normal,
            normal;
            border-radius: 44px;
            border: solid 3px #dddddd;
            font-size: 36px;
            color: #000000;
            margin: 0 34px;
            @extend %flex-center-center;
            .icon {
              background-size: cover;
              background-repeat: no-repeat;
              display: block;
              margin-right: 20px;
              &.qq {
                background-image: url("../assets/image/icon-qq.png");
                width: 37px;
                height: 38px;
              }
              &.tel {
                background-image: url("../assets/image/icon-tel.png");
                width: 36px;
                height: 36px;
              }
            }
          }
        }
      }
      .fix-content {
        @extend %fix-content;
        z-index: 99;
        background-color: #f1f1f1;
      }
    }
    .contentBehalf{
      color: #999999;
      font-size: 36px;
      padding: 44px;
      .behalfHead{
        h2{
          font-size: 40px;
          color: #000000;
          font-weight: normal;
        }
        p{
          padding:10px 0 ;
          span{
            float: right;
          }
        }
      }
      
      .behalfCont{
        border: 1px solid #d3d3d3;
        .clearfix:after,.clearfixli {
          display: block;
          clear: both;
          visibility: hidden;
          height: 0;
          overflow: hidden;
          content: "\20";
        }
        span{
          padding: 20px 0;
          color: #333333;
        }
        span:nth-last-child(2){
          border-left: 1px solid #d3d3d3;
          border-right: 1px solid #d3d3d3;
        }

        .clearfix,.clearfixli li {
          
          
          zoom: 1;
        }
        h2{
           font-size: 36px;
            font-weight: normal;
            text-align: center;
          span{
            display: block;
            width: 33%;
            float: left;
             background-color: #f1f1f1;
          }
          // span:first-child{
          //   background-color: #f1f1f1;
            
          // }
          span:nth-last-child(1){
            width: 34%;
          }
         
        }
        
        ul{
          li{
                border-top: 1px solid #d3d3d3;
            p{
              text-align: center;
              span{
                display: block;
                width: 33%;
                float: left;
                
              }
              .active{
                  color:#ff1314
                }
              span:first-child{
                background-color: #f1f1f1;
                
              }
              span:nth-last-child(1){
                width: 34%;
              }
            }
          }
        }
      }


      
    }
  }
</style>
